(function($, Global) {
    var FormMdpResetComponent = function(model) {
        this.model = model;
    }

	FormMdpResetComponent.prototype.initEvents = function() {
        this.publishers();
    }

	FormMdpResetComponent.prototype.publishers = function() {
        var self = this;

        $(document).on('submit', '.form-mdp-reset', function(e) {
            e.preventDefault();

            var $this = $(this);
            var data = $this.serializeJson();
            var $form = $this.closest('form');

            $.Topic('loader-show').publish('.page');

            self.model.resetMdp(data, $form, function(data) {
                $('section.banner.landing').toggleClass("hidden");
            });
        });
    }

	Global.FormMdpResetComponent = FormMdpResetComponent;
}(jQuery, window));